export default {
  nameImage: '',
}
